import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flexWrap", "leftColumnContent", "leftColumnHeader", "leftColumnFooter", "leftColumnMinWidth", "leftColumnScrollDirection", "leftScrollElementRef", "maxHeight", "rightColumnContent", "rightColumnFooter", "rightColumnHeader", "rightColumnScrollDirection", "rightColumnWidth", "rightScrollElementRef"];
import { ScrollingColumn } from '../ScrollingColumn/ScrollingColumn';
import { Flex } from '../../../components/Flex/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ScrollingColumns = _ref => {
  let {
      flexWrap = 'wrap',
      leftColumnContent,
      leftColumnHeader,
      leftColumnFooter,
      leftColumnMinWidth = '250',
      leftColumnScrollDirection = 'vertical',
      leftScrollElementRef,
      maxHeight = '100%',
      rightColumnContent,
      rightColumnFooter,
      rightColumnHeader,
      rightColumnScrollDirection = 'vertical',
      rightColumnWidth = '40%',
      rightScrollElementRef
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Flex, Object.assign({}, rest, {
    alignSelf: "stretch",
    blockSize: "100%",
    maxBlockSize: maxHeight,
    flexWrap: flexWrap,
    children: [/*#__PURE__*/_jsx(ScrollingColumn, {
      paddingInlineStart: "500",
      "data-scrolling-column": "left",
      paddingInlineEnd: "500",
      paddingBlockEnd: flexWrap === 'wrap' ? '400' : '0',
      minInlineSize: '0',
      flexBasis: leftColumnMinWidth,
      flexGrow: 9999,
      flexShrink: 1,
      footerContent: leftColumnFooter,
      headerContent: leftColumnHeader,
      maxHeight: maxHeight,
      scrollDirection: leftColumnScrollDirection,
      scrollElementRef: leftScrollElementRef,
      children: leftColumnContent
    }), /*#__PURE__*/_jsx(ScrollingColumn, {
      paddingInlineStart: "500",
      "data-scrolling-column": "right",
      minInlineSize: '0',
      flexBasis: rightColumnWidth,
      flexGrow: 1,
      flexShrink: 1,
      footerContent: rightColumnFooter,
      headerContent: rightColumnHeader,
      maxHeight: maxHeight,
      scrollDirection: rightColumnScrollDirection,
      scrollElementRef: rightScrollElementRef,
      children: rightColumnContent
    })]
  }));
};